import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import moment from 'moment';
import { makeStyles } from '@material-ui/styles';
import { Typography, Grid, Button, ButtonGroup } from '@material-ui/core';
import { DatePicker } from '@material-ui/pickers';
import EventNoteIcon from '@material-ui/icons/EventNote';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3)
  },
  dates: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  calendarTodayIcon: {
    marginRight: theme.spacing(1)
  }
}));

const Header = props => {
  const { className, title, startDate, endDate, onRangeChange, ...rest } = props;
  const classes = useStyles();
  const [selectEdge, setSelectEdge] = useState(null);
  const [calendarDate, setCalendarDate] = useState(moment());

  const handleCalendarOpen = edge => {
    setSelectEdge(edge);
  };

  const handleCalendarChange = date => {
    setCalendarDate(date);
  };

  const handleCalendarClose = () => {
    setCalendarDate(moment());
    setSelectEdge(null);
  };

  const handleCalendarAccept = date => {
    setCalendarDate(moment());
    if (selectEdge === 'start') {
      const nextStart = date;
      const nextEnd = moment(date).isAfter(endDate) ? date : endDate;
      onRangeChange && onRangeChange(nextStart, nextEnd);
    } else {
      const nextEnd = date;
      const nextStart = moment(date).isBefore(startDate) ? date : startDate;
      onRangeChange && onRangeChange(nextStart, nextEnd);
    }
    setSelectEdge(null);
  };

  const open = Boolean(selectEdge);

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Grid
        container
        justify="space-between"
        spacing={3}
      >
        <Grid
          item
          lg={6}
          xs={12}
        >
          <Typography
            component="h1"
            gutterBottom
            variant="h3"
          >
            {title || 'Analytics'}
          </Typography>
        </Grid>
        <Grid
          className={classes.dates}
          item
          lg={6}
          xs={12}
        >
          <ButtonGroup variant="contained">
            <Button onClick={() => handleCalendarOpen('start')}>
              <EventNoteIcon className={classes.calendarTodayIcon} />
              {moment(startDate).format('DD MMM YYYY')}
            </Button>
            <Button onClick={() => handleCalendarOpen('end')}>
              <EventNoteIcon className={classes.calendarTodayIcon} />
              {moment(endDate).format('DD MMM YYYY')}
            </Button>
          </ButtonGroup>
        </Grid>
      </Grid>
      <DatePicker
        maxDate={moment()}
        onAccept={handleCalendarAccept}
        onChange={handleCalendarChange}
        onClose={handleCalendarClose}
        open={open}
        style={{ display: 'none' }}
        value={calendarDate}
        variant="dialog"
      />
    </div>
  );
};

Header.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  onRangeChange: PropTypes.func
};

export default Header;
